import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from 'react-use';
import { useLocation } from 'react-router-dom';

import { logInFacebook, getAuthFlowFromPath, SIGNUP_PATH } from 'utils/auth';
import { FacebookLogo } from 'static';

import { Button } from './styled';

const FacebookAuthButton = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [prevAuth] = useLocalStorage<{ [key: string]: string }>(
    'socialSignIns',
    {},
  );
  const buttonText = useMemo(() => {
    let text = `${t('auth.signInWith')} Facebook`;

    if (location.pathname !== SIGNUP_PATH && prevAuth?.facebook) {
      text = `${t('auth.continueAs')} ${prevAuth.facebook}`;
    }

    return text;
  }, [prevAuth, location, t]);

  return (
    <Button
      type="button"
      onClick={() =>
        logInFacebook({
          flow: getAuthFlowFromPath(location.pathname),
        })
      }
    >
      <FacebookLogo />
      {buttonText}
    </Button>
  );
};

export default FacebookAuthButton;
